import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import CreditCardForm from "../BookingFlow/CreditCardForm";
import DateHelper from "../DateHelper/DateHelper";
import PortalReservationCheckinNavigation from "./PortalReservationCheckinNavigation";
import EmailedAgreementForm from "../FormBuilder/EmailedAgreementForm";

import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  ElementsConsumer,
  CardElement,
} from "@stripe/react-stripe-js";

class PortalReservationCheckin extends React.Component {
  constructor(props) {
    super(props);
    this.emailed_agreement_form_ref = React.createRef();
    this.state = {
      card: {},
      cards: [],
      displayNewCustomerCard: false,
      errors: [],
      loading: false,
      steps: [],
      reservation_segment: this.props.reservation_segment,
      payment_card_id: "",
      incidental_deposit_card_id: "",
      stripe: null,
      disableNameOnCard: false,
      displayCardResetButton: false,
      form: this.props.form,
      document_answers_save_path: this.props.form_save_path,
      form_fields: this.props.form_fields,
      customer: this.props.customer,
      initials: this.props.initials,
      property_link_color: this.props.property_link_color,
      blank_agreement_form: this.props.blank_agreement_form || false,
      property_button_background_color: this.props.property_button_background_color, 
      reservation_segment_id: this.props.reservation_segment_id,
      form_terms_path: this.props.form_terms_path,
      // disabledNext: false,
    };

    // default to segment if only one
    if (
      !this.state.reservation_segment &&
      this.props.reservation &&
      this.props.reservation.reservation_segments.length === 1
    ) {
      this.state.reservation_segment =
        this.props.reservation.reservation_segments[0];
    }

    // cards
    if (
      this.state.reservation_segment &&
      this.state.reservation_segment.customer &&
      this.state.reservation_segment.customer.cards
    ) {
      this.state.cards = this.state.reservation_segment.customer.cards;
    }

    // steps
    if (!this.state.reservation_segment) {
      this.state.steps.push("reservation_segments");
    }
    if(this.state.reservation_segment && this.props.blank_agreement_form == true && this.props.form != null) {
      this.state.steps.push("agreement");
    }
    if (this.state.reservation_segment && this.isPaymentRequired()) {
      this.state.steps.push("payment");
    }
    if (this.state.reservation_segment && this.isIncidentalDepositRequired()) {
      this.state.steps.push("incidental_deposit");
    }

    // room assignment
    if (this.state.reservation_segment) {
      if (this.state.reservation_segment.room) {
        this.state.room_id = this.state.reservation_segment.room.id;
      } else {
        var ready_rooms = this.state.reservation_segment.available_rooms.filter(
          (room) => {
            return (
              room.housekeeping_status === "clean" &&
              room.occupancy_status === "vacant"
            );
          }
        );
        if (ready_rooms.length > 0) {
          this.state.room_id = ready_rooms[0].id;
        } else {
          this.state.room_id = null;
        }
      }
    }

    // default step
    if (this.state.reservation_segment && this.props.blank_agreement_form == true && this.props.form != null) {
      this.state.step = "agreement";
    } else if (this.state.reservation_segment && this.isPaymentRequired())  {
      this.state.step = "payment";
    } else if (
      this.state.reservation_segment &&
      this.isIncidentalDepositRequired()
    ) {
      this.state.step = "incidental_deposit";
    } else if (
      this.state.reservation_segment &&
      !this.isIncidentalDepositRequired() &&
      !this.isPaymentRequired() &&
      this.isCheckInPermitted()
    ) {
      this.state.step = "finished";
    } else {
      this.state.step = "reservation_segments";
    }

    this.onAddCard = this.onAddCard.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeCardInput = this.onChangeCardInput.bind(this);
    this.onGotoStep = this.onGotoStep.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onSelectReservationSegment = this.onSelectReservationSegment.bind(this);
    this.isAgreementFormCompleted = this.isAgreementFormCompleted.bind(this);
  }

  async componentDidMount() {
    if (this.state.step === "finished") {
      this.onFinish();
    } else {
      const stripe = await loadStripe(this.props.public_gateway_key);
      this.setState({ stripe: stripe });
    }
  }

  /**
   * Render functions
   */

  render() { 
    const { reservation_segment } = this.state;

    if (
      (reservation_segment && reservation_segment.checked_in_at) ||
      this.state.step === "finished"
    ) {
      return [this.renderFinished(), <ModalButtons
        loading={this.state.loading}
        buttons={this.buttons()}
        key="buttons"
      />]
    } else {
      return (
        <div className="PortalReservationCheckin">
          {this.state.stripe ? (
            <Elements
              stripe={this.state.stripe}
              options={{
                locale:
                  navigator.languages && navigator.languages.length
                    ? navigator.languages[0]
                    : navigator.language,
              }}
            >
              <ElementsConsumer>
                {({ stripe, elements }) => [
                  this.renderStepNavigation(),
                  this.renderSteps(),
                  <ModalButtons
                    loading={this.state.loading}
                    buttons={this.buttons(elements)}
                    key="buttons"
                  />,
                ]}
              </ElementsConsumer>
            </Elements>
          ) : null}
          {!this.isCheckInPermitted() ? (
            <div>
              <div className="container">
                <div className="row">
                  <div className="col-sm-12">
                    <div
                      style={{ maxWidth: "420px", margin: "10px auto" }}
                      className="alert alert-danger"
                    >
                      <div className="text-center">
                        <strong>{I18n.t("check_in_not_available")}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          <LoadingSpinner show={this.state.loading} />
        </div>
      );
    }
  }

  renderStepNavigation = () => {
    if (this.isCheckInPermitted() && this.state.steps.length > 0) {
      return (
        <PortalReservationCheckinNavigation
          step={this.state.step}
          steps={this.state.steps}
          key="PortalReservationCheckinNavigation"
        />
      );
    }
  };

  renderSteps = () => {
    if (
      this.isCheckInPermitted() &&
      this.state.step === "reservation_segments"
    ) {
      // I can't see how we would end up hitting this.
      // The table that launches this component is a segment table with a single select option for check in.
      //  Moved and set regardless in case
      return this.renderRoomSelection();
    } else if (this.isCheckInPermitted() && this.state.step === "agreement") {
      return this.renderAgreementForm();
    }  else if (
      this.isCheckInPermitted() &&
      this.state.step !== "reservation_segments" &&
      this.state.step !== "finished"  
    ) {
      return this.renderForm();
    } else if (this.isCheckInPermitted() && this.state.step === "finished") {
      return this.renderFinished();
    }
  };

  renderErrors() {
    if (this.state.errors && this.state.errors.length > 0) {
      var errors = this.state.errors.map((error) => {
        return <li key={error}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFinished() {
    return (
      <div
        key="finished-message"
        className="alert alert-success text-center"
        style={{ maxWidth: "444px", margin: "5px auto" }}
      >
        {I18n.t("check_in_successful")}
      </div>
    );
  }

  renderForm() {
    return (
      <div className="container" key="incidental-or-payment">
        {this.state.step === "payment" && this.renderPayment()}
        {this.state.step === "incidental_deposit" &&
          this.renderIncidentalDeposit()}
      </div>
    );
  }

  renderAgreementForm() {
    return(
      <div key={this.state.form.id}>
        <EmailedAgreementForm
          ref={this.emailed_agreement_form_ref} 
          {...this.state} 
          id={this.props.form.id} 
          check_in_process={true} 
          title={this.state.form.title} 
          onGotoStep={this.onGotoStep}
          isAgreementFormCompleted={this.isAgreementFormCompleted}
          property_name={this.props.property_name}
          logo_image_url={this.props.property_logo_image}
          property_address={this.props.property_address}
          room_identifier={this.props.room_identifier}
          room_type_name={this.props.room_type_name} 
          confirmation_number={this.props.confirmation_number} 
          check_in_info={this.props.check_in_info}
          form_terms_path={this.props.form_terms_path}
          helper_template={this.props.helper_template ? this.props.helper_template : null} />
      </div>
    )
  }

  renderPayment() {
    var amount = this.getPaymentAmount();

    return (
      <div className="room-type">
        <div className="row">
          <div className="col-sm-3">
            <div className="panel panel-default payment-amount-explainer-panel">
              <div className="panel-body">
                <label style={{ color: "#777", marginBottom: "0px" }}>
                  {I18n.t("payment_amount")}
                </label>
                <h3 style={{ marginTop: "4px", marginBottom: "0px" }}>
                  ${new Intl.NumberFormat().format(amount / 100)}
                </h3>
                <div >
                  {I18n.t("this_room_requires_a_payment_before_check_in")}
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-9">
            {this.renderErrors()}
            {this.renderCardsOrCardForm("payment_card")}
          </div>
        </div>
      </div>
    );
  }

  renderIncidentalDeposit() {
    var self = this;

    var incidental_deposit = this.state.reservation_segment.incidental_deposit;

    if (incidental_deposit) {
      if (incidental_deposit.deposit_type === "store_a_valid_card") {
        return (
          <div className="room-type">
            <div className="row">
              <div className="col-sm-3">
                <div className="panel panel-default payment-amount-explainer-panel">
                  <div
                    className="panel-body"
                    dangerouslySetInnerHTML={{
                      __html: incidental_deposit.description,
                    }}
                  ></div>
                </div>
              </div>
              <div className="col-sm-9">
                {this.renderErrors()}
                {this.renderCardsOrCardForm("incidental_deposit_card")}
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="room-type">
            <div className="row">
              <div className="col-sm-3">
                <div className="panel panel-default payment-amount-explainer-panel">
                  <div className="panel-body">
                    <label style={{ color: "#777", marginBottom: "0px" }}>
                      {I18n.t("amount")}
                    </label>
                    <h3 style={{ marginTop: "4px", marginBottom: "0px" }}>
                      $
                      {new Intl.NumberFormat().format(
                        self.state.reservation_segment
                          .incidental_deposit_amount / 100
                      )}
                    </h3>
                    <div
                      
                      dangerouslySetInnerHTML={{
                        __html: incidental_deposit.description,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="col-sm-9">
                {this.renderErrors()}
                {this.renderCardsOrCardForm("incidental_deposit_card")}
              </div>
            </div>
          </div>
        );
      }
    } else {
      return <div className="none">{I18n.t("none")}</div>;
    }
  }

  renderCardsOrCardForm(card_type_name) {
    if (this.state.displayNewCustomerCard || this.state.cards.length === 0) {
      return (
        <div className="PaymentMethod">
          <div className="card" style={{ marginBottom: "7px" }}>
            <CreditCardForm
              card={this.state.card}
              customer={this.state.reservation_segment.customer}
              onChangeCardInput={this.onChangeCardInput}
              stacked={true}
              disableNameOnCard={this.state.disableNameOnCard}
              displayCardResetButton={this.state.displayCardResetButton}
              onResetCardElement={this.onResetCardElement}
              additionalClasses="container"
            />
          </div>
          {this.state.cards.length > 0 ? (
            <p>
              <a href="#" onClick={this.onAddCard}>
                {I18n.t(
                  !this.state.displayNewCustomerCard
                    ? "add_new_card"
                    : "use_existing_cards"
                )}
              </a>
            </p>
          ) : null}
        </div>
      );
    } else {
      var cards = this.state.cards.map((card) => {
        return (
          <div
            className={
              "card well " +
              (this.state[card_type_name + "_id"] == card.id
                ? "card-selected"
                : "")
            }
            key={card.id}
          >
            <label>
              <input
                type="radio"
                name={card_type_name + "_id"}
                value={card.id}
                checked={this.state[card_type_name + "_id"] == card.id}
                onChange={this.onChange}
              />
              <span className={"credit-card-icon small " + card.brand}></span>
              <span className="card-detail-text">
                {I18n.t("ending_in").toLowerCase()}{" "}
                <strong>{card.last_4}</strong>
              </span>
            </label>
          </div>
        );
      });

      return (
        <div className="PaymentMethod">
          <div className="cards">{cards}</div>
          <p>
            <a href="#" onClick={this.onAddCard}>
              {I18n.t(
                !this.state.displayNewCustomerCard
                  ? "add_new_card"
                  : "use_existing_cards"
              )}
            </a>
          </p>
        </div>
      );
    }
  }

  renderRoomSelection() {
    return (
      <div>
        <h4 className="text-center">
          {I18n.t("which_room_would_you_like_to_checkin")}
        </h4>

        <div className="row room-selection">{this.renderRooms()}</div>
      </div>
    );
  }

  renderRooms() {
    var rooms = this.props.reservation.reservation_segments.map((segment) => {
      return (
        <div className="room well" key={segment.id}>
          <h4>{segment.room_type.name}</h4>
          <h5>
            {DateHelper.printDateToScreen(
              segment.check_in_date,
              this.props.date_format
            )}{" "}
            &ndash;{" "}
            {DateHelper.printDateToScreen(
              segment.check_out_date,
              this.props.date_format
            )}
          </h5>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.onSelectReservationSegment.bind(this, segment.id)}
          >
            {I18n.t("next")}
          </button>
        </div>
      );
    });

    return rooms;
  }

  renderCardAssociations = (card) => {
    if (
      card.reservation_card &&
      card.display_with_customer &&
      card.room_incidental_card
    ) {
      return `(${I18n.t("reservation_booking_card")}, ${I18n.t(
        "room_incidental_card"
      )}, ${I18n.t("saved_customer_card")})`;
    } else if (card.reservation_card && card.room_incidental_card) {
      return `(${I18n.t("reservation_booking_card")}, ${I18n.t(
        "room_incidental_card"
      )})`;
    } else if (card.reservation_card && card.display_with_customer) {
      return `(${I18n.t("reservation_booking_card")}, ${I18n.t(
        "saved_customer_card"
      )})`;
    } else if (card.reservation_card) {
      return `(${I18n.t("reservation_booking_card")})`;
    } else if (card.room_incidental_card && card.display_with_customer) {
      return `(${I18n.t("room_incidental_card")}, ${I18n.t(
        "saved_customer_card"
      )})`;
    } else if (card.room_incidental_card) {
      return `(${I18n.t("room_incidental_card")})`;
    } else if (card.display_with_customer) {
      return `(${I18n.t("saved_customer_card")})`;
    }
  };

  /**
   * Change handlers
   */

  onAddCard() {
    var state = {
      displayNewCustomerCard: !this.state.displayNewCustomerCard,
      card: { name_on_card: "" },
      displayCardResetButton: false,
      disableNameOnCard: false,
    };
    if (this.state.step === "payment") {
      state.payment_card_id = "";
    } else if (this.state.step === "incidental_deposit") {
      state.incidental_deposit_card_id = "";
    }
    this.setState(state);
  }

  onChange(e) {
    var { state } = this;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  onChangeCardInput(e) {
    var { card } = this.state;
    card[e.target.name] = e.target.value;
    this.setState({ card: card });
  }

  onGotoStep(step) {
    this.setState({ step: step });
  }

  onNext(elements) {
    if (this.state.step === "reservation_segments") {
      if (this.state.steps.includes("payment")) {
        this.setState({ step: "payment", displayNewCustomerCard: false });
      } else if (this.state.steps.includes("incidental_deposit")) {
        this.setState({
          step: "incidental_deposit",
          displayNewCustomerCard: false,
        });
      }
    } else if (this.state.step === "agreement") {
      this.emailed_agreement_form_ref.current.onSubmit();
    } else if (this.state.step === "payment") {
      if (this.state.steps.includes("incidental_deposit")) {
        // next step incidental_deposit
        if (
          this.state.displayNewCustomerCard ||
          this.state.cards.length === 0
        ) {
          // save card first
          this.setState({ loading: true, errors: [] }, () => {
            this.saveCardAPI(elements)
              .then((data) => {
                if (data && data.errors) {
                  this.setState({ loading: false, errors: data.errors });
                } else {
                  var card = data.success;
                  var { cards } = this.state;
                  cards.unshift(card);
                  this.setState({
                    loading: false,
                    step: "incidental_deposit",
                    cards: cards,
                    payment_card_id: card.id,
                    incidental_deposit_card_id: card.id,
                    displayNewCustomerCard: false,
                    card: {},
                  });
                }
              })
              .catch((response) => {
                this.setState({ loading: false, errors: response });
              });
          });
        } else if (
          this.state.payment_card_id &&
          this.state.payment_card_id !== ""
        ) {
          // all good to proceed
          this.setState({
            loading: false,
            errors: [],
            step: "incidental_deposit",
            incidental_deposit_card_id: this.state.payment_card_id,
          });
        } else {
          this.setState({ errors: [I18n.t("please_select_a_card")] });
        }
      } else {
        // next step is finish
        this.onFinish();
      }
    } else if (this.state.step === "incidental_deposit") {
      if (this.state.displayNewCustomerCard || this.state.cards.length === 0) {
        // save card first
        this.setState({ loading: true, errors: [] }, () => {
          this.saveCardAPI(elements)
            .then((data) => {
              if (data && data.errors) {
                this.setState({ loading: false, errors: data.errors });
              } else {
                var card = data.success;
                var { cards } = this.state;
                cards.unshift(card);
                this.setState(
                  {
                    displayNewCustomerCard: false,
                    card: {},
                    cards: cards,
                    incidental_deposit_card_id: card.id,
                  },
                  () => {
                    this.onFinish();
                  }
                ); //TODO FINISH
              }
            })
            .catch((response) => {
              this.setState({ loading: false, errors: response });
            });
        });
      } else if (
        this.state.incidental_deposit_card_id &&
        this.state.incidental_deposit_card_id !== ""
      ) {
        // all good to proceed
        this.onFinish();
      } else {
        this.setState({ errors: [I18n.t("please_select_a_card")] });
      }
    }
  }

  onPrev() {
    if (this.state.step === "reservation_segments") {
      // can't go back
    } else if (this.state.step === "payment") {
      if (this.state.steps.includes("reservation_segments")) {
        this.setState({ step: "reservation_segments" });
      } else {
        // can't go back
      }
    } else if (this.state.step === "incidental_deposit") {
      if (this.state.steps.includes("payment")) {
        this.setState({ step: "payment" });
      } else if (this.state.steps.includes("reservation_segments")) {
        this.setState({ step: "reservation_segments" });
      } else {
        // can't go back
      }
    }
  }

  onFinish() {
    this.setState({ loading: true }, () => {
      // both payment and incidental required
      if (this.isPaymentRequired() && this.isIncidentalDepositRequired()) {
        this.createPaymentAPI().then((data) => {
          if (data.success) {
            this.incidentalDepositCardAPI().then((data) => {
              this.checkInAPI().then((data) => {
                if (data.success) {
                  this.setState({ loading: false, step: "finished" });
                  window.refresh_data();
                } else {
                  this.setState({
                    loading: false,
                    errors: [I18n.t("problem_with_check_in")],
                  });
                }
              });
            });
          } else {
            this.setState({
              loading: false,
              errors: [I18n.t("problem_with_check_in")],
            });
          }
        });
      }

      // only payment required
      if (this.isPaymentRequired() && !this.isIncidentalDepositRequired()) {
        this.createPaymentAPI().then((data) => {
          if (data.success) {
            this.checkInAPI().then((data) => {
              if (data.success) {
                this.setState({ loading: false, step: "finished" });
                window.refresh_data();
              } else {
                this.setState({
                  loading: false,
                  errors: [I18n.t("problem_with_check_in")],
                });
              }
            });
          } else {
            this.setState({
              loading: false,
              errors: [I18n.t("problem_with_check_in")],
            });
          }
        });
      }

      // only incidental deposit required
      if (this.isIncidentalDepositRequired() && !this.isPaymentRequired()) {
        this.incidentalDepositCardAPI().then((data) => {
          if (data.success) {
            this.checkInAPI().then((data) => {
              if (data.success) {
                this.setState({ loading: false, step: "finished" });
                window.refresh_data();
              } else {
                this.setState({
                  loading: false,
                  errors: [I18n.t("problem_with_check_in")],
                });
              }
            });
          } else {
            this.setState({
              loading: false,
              errors: [I18n.t("problem_with_check_in")],
            });
          }
        });
      }

      // no payment or incidental deposit required
      if (!this.isIncidentalDepositRequired() && !this.isPaymentRequired()) {
        this.checkInAPI().then((data) => {
          if (data.success) {
            this.setState({ loading: false, step: "finished" });
            window.refresh_data();
          } else {
            this.setState({
              loading: false,
              errors: [I18n.t("problem_with_check_in")],
            });
          }
        });
      }
    });
  }

  onSelectReservationSegment(reservation_segment_id) {
    var reservation_segment = null;
    for (
      var i = 0, ilen = this.props.reservation.reservation_segments.length;
      i < ilen;
      i++
    ) {
      reservation_segment = this.props.reservation.reservation_segments[i];
      if (reservation_segment.id === reservation_segment_id) {
        break;
      }
    }
    this.setState({ reservation_segment: reservation_segment });
  }

  /**
   * API endpoint functions
   */

  checkInAPI() {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: this.props.check_in_path,
        type: "POST",
        data: {
          reservation_segment_id: this.state.reservation_segment.id,
          room_id: this.state.room_id,
          room_group_id: this.state.room_group_id,
        },
      }).done(function (data) {
        resolve(data);
      });
    });
  }

  createPaymentAPI() {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: this.props.create_payment_path,
        type: "POST",
        data: {
          reservation_segment_id: this.state.reservation_segment.id,
          card_id: this.state.payment_card_id,
          amount: this.getPaymentAmount(),
        },
      }).done(function (data) {
        resolve(data);
      });
    });
  }

  incidentalDepositCardAPI() {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: this.props.incidental_deposit_card_path,
        type: "POST",
        data: {
          reservation_segment_id: this.state.reservation_segment.id,
          card_id: this.state.incidental_deposit_card_id,
          amount:
            this.state.reservation_segment.incidental_deposit_amount || null,
        },
      }).done(function (data) {
        resolve(data);
      });
    });
  }

  saveCardAPI(elements) {
    return new Promise(async (resolve, reject) => {
      if (
        !this.state.card.name_on_card ||
        /\d/.test(this.state.card.name_on_card)
      ) {
        reject([I18n.t("name_on_card_error")]);
      } else {
        var stripe = this.state.stripe;
        var cardElement = elements.getElement(CardElement);

        if (!stripe || !elements) {
          console.log(
            "We should never hit this! Either Stripe or Elements is not loaded!"
          );
          return;
        }

        const result = await stripe.createPaymentMethod({
          type: "card",
          card: cardElement,
          billing_details: {
            name: this.state.card.name_on_card,
          },
        });

        this.setState({
          disableNameOnCard: true,
          displayCardResetButton: true,
        });

        if (result.error) {
          reject([result.error.message]);
        } else if (result.paymentMethod) {
          $.ajax({
            url: this.props.customer_store_card_path,
            type: "POST",
            data: {
              customer_id: this.state.reservation_segment.customer.id,
              payment_token: result.paymentMethod,
            },
          }).done(function (data) {
            resolve(data);
          });
        } else {
          console.log("should not hit here - potential async issue");
        }
      }
    });
  }

  /**
   * Helper functions
   */

  buttons(elements) {
    var self = this;
    var btns = [];
    if (this.state.step === "finished" || !this.isCheckInPermitted()) {
      btns.push({
        name: I18n.t("done"),
        html_attributes: ['data-dismiss="modal"'],
      });
    } else {
      btns.push({
        name: I18n.t("cancel"),
        html_attributes: ['data-dismiss="modal"'],
      });

      if (this.state.reservation_segment && this.state.step !== "agreement") {
        if (this.state.steps && this.state.steps.length > 1) {
          //
          btns.push({
            name: I18n.t("prev"),
            button_classes: [
              "primary " +
                (this.state.steps.indexOf(this.state.step) === 0
                  ? "disabled"
                  : ""),
            ],
            onClick: function (e) {
              e.stopPropagation();
              e.preventDefault();

              self.onPrev();
            },
          });
        }

        btns.push({
          name: I18n.t("next"),
          // button_classes: ["primary"],
          button_classes: [
            "primary "
          ],
      
          onClick: function (e) {
            e.stopPropagation();
            e.preventDefault();

            self.onNext(elements);
          },
        });
      }
    }

    return btns;
  }

  getPaymentAmount() {
    if (
      this.state.reservation_segment &&
      this.state.reservation_segment.billing_policy &&
      this.state.reservation_segment.billing_policy.deposit_lifecycle_event ===
        "check_in_date" &&
      this.state.reservation_segment.billing_policy.deposit_time_period ===
        "immediately"
    ) {
      return this.state.reservation_segment.deposit_amount;
    } else if (
      this.state.reservation_segment &&
      this.state.reservation_segment.billing_policy &&
      this.state.reservation_segment.billing_policy
        .capture_balance_lifecycle_event === "check_in_date" &&
      this.state.reservation_segment.billing_policy
        .capture_balance_time_period === "immediately"
    ) {
      return this.state.reservation_segment.balance_amount;
    } else {
      return 0;
    }
  }

  isCheckInPermitted() {
    if (this.props.check_in_status == "ready_to_check_in") {
      return true;
    } else {
      return false;
    }
  }

  isPaymentRequired() {
    var amount = this.getPaymentAmount();

    if (
      this.state.reservation_segment &&
      this.state.reservation_segment.billing_policy &&
      this.state.reservation_segment.billing_policy.deposit_lifecycle_event ===
        "check_in_date" &&
      this.state.reservation_segment.billing_policy.deposit_time_period ===
        "immediately" &&
      amount
    ) {
      return true;
    } else if (
      this.state.reservation_segment &&
      this.state.reservation_segment.billing_policy &&
      this.state.reservation_segment.billing_policy
        .capture_balance_lifecycle_event === "check_in_date" &&
      this.state.reservation_segment.billing_policy
        .capture_balance_time_period === "immediately" &&
      amount
    ) {
      return true;
    } else {
      return false;
    }
  }

  isIncidentalDepositRequired() {
    if (
      this.state.reservation_segment &&
      this.state.reservation_segment.incidental_deposit
    ) {
      if (
        this.state.reservation_segment.incidental_deposit.deposit_type ===
        "none"
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  isAgreementFormCompleted(steps) {
    // this.setState({ step: step });
    this.setState({ blank_agreement_form: false, steps: steps });
    window.refresh_data();
  }

  onResetCardElement = () => {
    this.setState({
      loading: false,
      disableNameOnCard: false,
      displayCardResetButton: false,
      card: { name_on_card: "" },
    });
  };
}

export default PortalReservationCheckin;
